import { render, staticRenderFns } from "./ScalaCell.vue?vue&type=template&id=ac67b00e&"
import script from "./ScalaCell.vue?vue&type=script&lang=js&"
export * from "./ScalaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports